import { useEffect, EffectCallback, DependencyList, useRef } from 'react'

export const useNonInitialEffect = (
  effect: EffectCallback,
  deps?: DependencyList,
): void => {
  const initialRender = useRef(true)

  useEffect(() => {
    let effectReturns

    if (initialRender.current) {
      initialRender.current = false
    } else {
      effectReturns = effect()
    }

    if (effectReturns && typeof effectReturns === 'function') {
      return effectReturns
    }
  }, deps)
}
